<template>
  <VcLayout class="VcImage" justify-content-center :data-qa="dataQa">
    <img v-if="image && typeof image === 'string'" class="image" :src="image" />
    <component :is="image" v-else class="image" />
  </VcLayout>
</template>

<script>
import VcLayout from '../VcLayout/VcLayout.vue';
export default {
  name: 'VcImage',
  components: { VcLayout },
  props: {
    image: {
      type: [String, Object],
      required: true,
    },
    dataQa: {
      type: String,
      default: 'VcImage',
    },
  },
};
</script>

<style lang="scss" scoped>
.VcImage {
  height: 100%;
  justify-content: center;

  ::v-deep img {
    height: 100%;
  }

  ::v-deep svg {
    max-width: 100%;
    height: 100%;
  }
}
</style>
